import { environment } from 'environments';

const { protocol, hostname, port } = window.location;
const baseUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;

const amplifyConfig = {
  Auth: {
    Cognito: {
      region: environment.cognito.region,
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.clientId,
      loginWith: {
        oauth: {
          domain: environment.cognito.domain,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [baseUrl],
          redirectSignOut: [baseUrl + '/login'],
          responseType: 'code' as const,
        },
      },
    },
  },
};
export default amplifyConfig;
